import getEnvironDomain from 'utils/getEnvironDomain';
import { IAccount } from 'interfaces/IAccount';

class AccountDataModel {
  private account: IAccount;

  constructor(account: IAccount) {
    this.account = account;
  }

  get firmName(): string {
    return this.account?.firm_name || '';
  }

  get fullFirmName(): string {
    return this.account?.full_firm_name || '';
  }

  get linkToPassport(): string {
    return `//${getEnvironDomain()}/firms/${this.account?.account_id}`;
  }
}

export default AccountDataModel;
